import { render, staticRenderFns } from "./PlusImageUploadCroppie.vue?vue&type=template&id=48ef1d1e&scoped=true"
import script from "./PlusImageUploadCroppie.vue?vue&type=script&lang=js"
export * from "./PlusImageUploadCroppie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ef1d1e",
  null
  
)

export default component.exports